//!#system	

//!#system	

<template>
	<v-container fill-height>
		<v-layout align-center justify-center>
			<v-flex xs12 sm8 md4>
				<v-card class="elevation-12">
					<v-toolbar dark color="primary">
						<v-toolbar-title>Sign out</v-toolbar-title>
					</v-toolbar>
					<v-card-text>
						<v-alert v-if="errorState" :value="true" color="error" icon="fa-exclamation-triangle">
							{{errorMessage}}
						</v-alert>
						<v-alert v-if="infoState" type="info">
							{{infoMessage}}
						</v-alert>
						
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn to="/sign-in">Sign in again</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>

export default {
	name: 'Signout',
	data() {
		console.log(this.$route.params);
		return {
			errorState: false,
			errorMessage: '',
			infoState: false,
			infoMessage: ''
		};
	},
	methods: {
		signout() {
			this.$store.dispatch('authentication/userSignout', {
				callback: (err, response, meta) => {
					console.log(err, response, meta);
					if (err) {
						this.errorState = true;
						this.errorMessage = meta.validation.messages.join('\r\n');
					} else {
						this.infoState = true;
						this.infoMessage = 'You have been signed out.';
					}
					window.location.replace('/ui/sign-in');
				}
			});
		}
	},
	created() {
		this.signout();
	}
};
</script>
<style scoped>
</style>